import axios from 'axios'

class ParametrosApiClient {

    async buscarTodosParametros() {
        return axios.get('api/configuracao/parametros')
    }
}

export default new ParametrosApiClient()
